<script setup lang="ts">
import { helpers } from '@vuelidate/validators'
import { useVModel } from '@vueuse/core'

import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: boolean
}

const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)
const { LocalConfigurationStore } = stores()

const v$ = useValidation(
  () => ({
    model: {
      accepted: helpers.withMessage(
        'Para continuar es necesario aceptar los terminos y condiciones.',
        () => model.value
      ),
    },
  }),
  { model },
  { $scope: Form.tos, $registerAs: Form.tos }
)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.tos">
    <FormsGlobalTitle
      text="Términos y condiciones"
      icon-class="icon-[ph--book-open-bold]"
    />

    <InputContainer
      class="col-span-full"
      :error="v$.model?.$error"
      :error-message="v$.model?.$errors[0]?.$message.toString()"
      grow
    >
      <div class="flex items-center gap-3">
        <PvCheckbox v-model="model" />
        <div class="grid gap-4">
          <span
            v-if="LocalConfigurationStore?.brokerContext?.termsAndConditions?.text"
            v-dompurify-html="LocalConfigurationStore.brokerContext.termsAndConditions.text"
            class="text-sm"
            @click="model = !model"
          />
          <span v-else>He leído y acepto los terminos y condiciones.</span>
          <div>
            <div
              v-for="(l, i) in LocalConfigurationStore?.brokerContext?.termsAndConditions
                ?.extenalLinks"
              :key="i"
              class="cursor-pointer underline text-primary flex items-center"
            >
              <span class="icon-[ph--file-text]" />
              <span
                aria-label="Terminos y condiciones"
                @click="
                  navigateTo(l.url, {
                    open: { target: '_blank' },
                  })
                "
              >
                {{ l.text }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </InputContainer>
  </FormsGlobalContainer>
</template>
